// Auto-generated normalizer for table: ExamenPreguntaTextoLibre
export function examenPreguntaTextoLibreNormalize(row) {
  return {
    idExamenRespuestaTextoLibre: row.idExamenRespuestaTextoLibre ?? row.IdExamenRespuestaTextoLibre ?? row['IdExamenRespuestaTextoLibre'] ?? 0,
    idExamenPregunta: row.idExamenPregunta ?? row.IdExamenPregunta ?? row['IdExamenPregunta'] ?? 0,
    longitudMaxima: row.longitudMaxima ?? row.LongitudMaxima ?? row['LongitudMaxima'] ?? '',
    palabrasClave: row.palabrasClave ?? row.PalabrasClave ?? row['PalabrasClave'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
